<template>
  <div>
      <section class="section">
          <p class="title is-3">Carrito de compra</p>
          <!-- <p class="subtitle is-5">{{ allItems }}</p> -->
      </section>
      <section class="section">
          <b-table :data="allItems">
              <template slot-scope="props">
                <b-table-column field="id" label="Código" width="50" centered>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="first_name" label="Producto">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="last_name" label="Precio" numeric>
                    $ {{ props.row.precio }}
                </b-table-column>

                <b-table-column label="Cantidad" width="250">
                    <span>
                        <b-field>
                            <b-numberinput controls-position="compact" v-model="props.row.cantidad"></b-numberinput>
                        </b-field>
                    </span>
                </b-table-column>

                <b-table-column field="last_name" label="Total" numeric>
                    {{ props.row.precio * props.row.cantidad }}
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                pack="far"
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nada en el carrito aún</p>
                    </div>
                </section>
            </template>
            
          </b-table>
      </section>
      <section class="section">
          <div class="buttons">
              <b-button class="is-danger is-large">Limpiar carro</b-button>
              <b-button class="is-success is-large">Proceder a pago</b-button>
          </div>
      </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    name: 'Cart',
    data() {
        return {
            
        }
    },
    computed: mapGetters(["allItems"]),
    methods: {
        ...mapActions(["fetchItems"])
    },
}
</script>

<style>

</style>